var _GD = _GD || {};

if (typeof console == "undefined")
    var console = {
        log: function() {}
    };


_GD.is_touch_device = function() {
    //        return !!('ontouchstart' in window);
    return /(iphone|ipod|ipad|android|iemobile|blackberry|bada)/.test(window.navigator.userAgent.toLowerCase());
};

_GD.is_touch = _GD.is_touch_device();
_GD.ie11 = !!window.MSInputMethodContext && !!document.documentMode;
_GD.is_mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;



if (_GD.is_touch) { // remove all :hover stylesheets
    try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;

            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                if (!styleSheet.rules[ri].selectorText) continue;

                if (styleSheet.rules[ri].selectorText.match(':hover')) {
                    styleSheet.deleteRule(ri);
                }
            }
        }
    } catch (ex) {}

}








/*
 ######  ##     ##  ######
##    ## ##     ## ##    ##
##       ##     ## ##
 ######  ##     ## ##   ####
      ##  ##   ##  ##    ##
##    ##   ## ##   ##    ##
 ######     ###     ######
*/

_GD.svgs = {};
_GD.svgtoPathHelper = function($svg, imgURL) {
	var $_img = $('img[src^="'+imgURL+'"]');
		$_img.each(function(index, el) {
			var $_svg = $svg.clone();
			$(el).replaceWith($_svg);
			$_svg.removeClass('invisible');
			$_svg.css({ 'visibility': 'visible' });
		});
}
_GD.svgtoPath = function() {
    // $('img[src$=".svg"]').addClass('invisible').each(function() {
    $('img.svg').addClass('invisible').each(function() {
        var $img = $(this);
        var imgURL = $img.attr('src');
            imgURL = imgURL.replace(/\?.+/,'');
        var attributes = $img.prop("attributes");
        var $svg;
        if (!_GD.svgs[imgURL]) {
            _GD.svgs[imgURL] = {};
            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                $svg = $(data).find('svg');
                // Remove any invalidT5'';,M;LMNMKK N,M XML tags
                $svg = $svg.removeAttr('xmlns:a');
                // Loop through IMG attributes and apply on SVG
                $.each(attributes, function() {
                    $svg.attr(this.name, this.value);
                });
                _GD.svgs[imgURL] = $svg;
                // Replace IMG with SVG
                _GD.svgtoPathHelper($svg, imgURL);
            }, 'xml');
        } else {
            $svg = _GD.svgs[imgURL];
            if ($svg.length){
				// дубль
                _GD.svgtoPathHelper($svg, imgURL);
            }
        }
    });
};



/*
##     ## #### ########  ########  #######
##     ##  ##  ##     ## ##       ##     ##
##     ##  ##  ##     ## ##       ##     ##
##     ##  ##  ##     ## ######   ##     ##
 ##   ##   ##  ##     ## ##       ##     ##
  ## ##    ##  ##     ## ##       ##     ##
   ###    #### ########  ########  #######
*/


// if (!_GD.is_touch) {
    window.addEventListener('focus', function() {
        setTimeout(function () {
            //  document.title = 'focused';
            var vidos = document.getElementsByTagName("video");
            if (!vidos) {
                return;
            }

            $.each(vidos, function(index, el) {
                if (!$(el).data('vidosPaused') && !$(el).parents('.outview').length) {
                    el.play();
                }
            });

        }, 10);

    });

    window.addEventListener('blur', function() {
        //  document.title = 'not focused';
        setTimeout(function () {

            var vidos = document.getElementsByTagName("video");
            if (!vidos) {
                return;
            }
            $.each(vidos, function(index, el) {
                el.pause();
            });
        }, 10);
    });
// } else {
//
    setTimeout(function () {
        var vidos = document.getElementsByTagName("video");
        $.each(vidos, function(index, el) {
            if (!$(el).data('vidosPaused')) {
                el.play();
            }
        });
        // if (window.matchMedia('(prefers-reduced-motion)').matches) {
        //     alert("prefers-reduced-motion");
        // }
        // alert(window.matchMedia('(prefers-reduced-motion)').matches);
    }, 10);
//
// }





$(document).ready(function() {

    if (/(iphone|ipod|ipad)/.test(window.navigator.userAgent.toLowerCase())) {
         $('#iosFix').attr('data-toggler', 'fix');
    } else {
        $('#iosFix').attr('data-toggler', 'none');
    }



    $(document).foundation();

    _GD.$top = $('#header');

    _GD.$top.headroom();
    // $(window).on('scroll', function(e){
    //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //
    //     if (scrollTop > 0 && !_GD.$top.hasClass('scrolled')) {
    //         _GD.$top.addClass('scrolled');
    //     }
    //     if (scrollTop <= 0){
    //         _GD.$top.removeClass('scrolled');
    //     }
    //
    // }).trigger('scroll');


    // $(document).on('click', '.zoom-in', function (e) {
    //     setTimeout(function () {
    //         $('#back').scrollLeft(100).scrollTop(300);
    //     }, 0);
    // });
    // $(document).on('click', '.zoom-out', function (e) {
    //     e.preventDefault();
    //     $('#back').scrollLeft(0).scrollTop(0);
    // });

/*
#### ##     ##  ######    ######  ########    ###    ######## ##     ##  ######
 ##  ###   ### ##    ##  ##    ##    ##      ## ##      ##    ##     ## ##    ##
 ##  #### #### ##        ##          ##     ##   ##     ##    ##     ## ##
 ##  ## ### ## ##   ####  ######     ##    ##     ##    ##    ##     ##  ######
 ##  ##     ## ##    ##        ##    ##    #########    ##    ##     ##       ##
 ##  ##     ## ##    ##  ##    ##    ##    ##     ##    ##    ##     ## ##    ##
#### ##     ##  ######    ######     ##    ##     ##    ##     #######   ######
*/
    imgStatus.watch('.full_visual.first i', function(imgs) {

        if (imgs.isDone()){
            console.log("imgsIsDone", imgs.isDone());
            $('#body > .spinner.loading').removeClass('loading');
        }

    });



    /*
     ######     ###    ##       ##       ########     ###     ######  ##    ##
    ##    ##   ## ##   ##       ##       ##     ##   ## ##   ##    ## ##   ##
    ##        ##   ##  ##       ##       ##     ##  ##   ##  ##       ##  ##
    ##       ##     ## ##       ##       ########  ##     ## ##       #####
    ##       ######### ##       ##       ##     ## ######### ##       ##  ##
    ##    ## ##     ## ##       ##       ##     ## ##     ## ##    ## ##   ##
     ######  ##     ## ######## ######## ########  ##     ##  ######  ##    ##
    */

    if($(location.hash).length && location.hash == '#callback'){
        $('#callback, #callbackContent, #iosFix').foundation('toggle');
    }

    if($(location.hash).length && location.hash == '#request'){
        $('#request, #requestContent, #iosFix').foundation('toggle');
    }
    
    console.log('check callback');
    if($(location.hash).length && location.hash == '#requestPrice'){
        // $('#requestPrice, #requestPriceContent, #iosFix').foundation('toggle');
        console.log('_GD', _GD);
        setTimeout(function(){
            _GD.requestPrice('Специальные предложения');
        }, 100);
    }


    /*

    ########  ##     ##  #######  ##    ## ########
    ##     ## ##     ## ##     ## ###   ## ##
    ##     ## ##     ## ##     ## ####  ## ##
    ########  ######### ##     ## ## ## ## ######
    ##        ##     ## ##     ## ##  #### ##
    ##        ##     ## ##     ## ##   ### ##
    ##        ##     ##  #######  ##    ## ########

    */

    _GD.setTel = function () {
        _GD.tel = $('header .show-for-small-only.call, .b-call .call').text()
                                    .replace(/(?:\r\n|\r|\n)/g, '')
                                    .replace(/(?:\s)/g, '')
                                    .replace(/^(?:\+7\(383\))+/g,'')
                                    .replace(/[()-]+/g,'');
        console.log("tel", _GD.tel);
        if (!$('.call a').length) {
            $('.call').wrapInner('<a href="tel:+7383'+_GD.tel+'" />');
        }
    }
    // if (_GD.is_touch) {
		$(window).on('load', function(event) {
			 _GD.setTel();
		});
    // }
    setTimeout(function () {
        _GD.setTel();
    }, 100);

    /*
    ########  ##       ##     ## ########     ###    ##
    ##     ## ##       ##     ## ##     ##   ## ##   ##
    ##     ## ##       ##     ## ##     ##  ##   ##  ##
    ########  ##       ##     ## ########  ##     ## ##
    ##        ##       ##     ## ##   ##   ######### ##
    ##        ##       ##     ## ##    ##  ##     ## ##
    ##        ########  #######  ##     ## ##     ## ########
    */
    _GD.declOfNum = function(number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }

});

// setTimeout(function () {
//     $('#body').foundation('toggle');
// }, 5000);
_GD.buildAll = function (all) {

    var template =
        '<% for(var index in this) { %>' +
        '<a href="<% this[index].image.url %>">' +
        '<img data-lazy="<% this[index].image.thumbnail %>" />' +
        '</a>' +
        '<% } %>'
        ;
    // console.log('template', _GD.Templa(template, all));
    $('#gallery').html(_GD.Templa(template, all));

    setTimeout(function() {

        var $gallery = $('#gallery');
        var $galleryNav = $('#galleryNav');
        _GD.slickNums($gallery, $galleryNav);

        $gallery.slick({
            // lazyLoad: 'ondemand',
            lazyLoad: 'anticipated',
            // mobileFirst: true,
            swipeToSlide: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            centerMode: true,
            arrows: !false,
            appendArrows: $galleryNav,
            // prevArrow: '<a class="_slick-prev"></a>',
            // nextArrow: '<a class="_slick-next"></a>',
            centerPadding: '0',
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        arrows: !false,
                        centerMode: true,
                        // centerPadding: '40px',
                        slidesToShow: 5
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: !false,
                        centerMode: true,
                        // centerPadding: '40px',
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        arrows: !false,
                        centerMode: true,
                        // centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 479,
                    settings: {
                        arrows: !false,
                        centerMode: true,
                        // centerPadding: '40px',
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 360,
                    settings: {
                        arrows: !false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                }
            ]
        });



        $gallery.magnificPopup({
            delegate: 'a', // child items selector, by clicking on it popup will open
            type: 'image',
            // other options
            mainClass: 'mfp-zoom-in',
			tLoading: '',
            tError: '',
			removalDelay: 500, //delay removal by X to allow out-animation
			callbacks: {

				imageLoadComplete: function() {
					var self = this;
					setTimeout(function() {
						self.wrap.addClass('mfp-image-loaded');
					}, 16);

					// var h = $('.mfp-img').height();
					// var _h = $('.mfp-figure').height();
					// var _T = ( _h - h ) * 0.5 ;
                    //
					// $('.mfp-bottom-bar').css({'bottom':_T+'px'});
				}

				,close: function() {
					this.wrap.removeClass('mfp-image-loaded');
				}

				,markupParse: function(){
					setTimeout(function(){

						//Enable swiping...
						// $(".mfp-img").swipe( {
						// 	//Generic swipe handler for all directions
						// 	swipe:function(event, direction, distance, duration, fingerCount) {
						// 		///$(this).text("You swiped " + direction );
                        //
						// 		if (direction == 'right'/* || direction == 'up'*/) {
						// 		 $.magnificPopup.instance.prev(); // go to prev item
						// 		}
						// 		if (direction == 'left'/* || direction == 'down'*/) {
						// 		 $.magnificPopup.instance.next(); // go to next item
						// 		}
						// 	},
						// 	//Default is 75px, set to 0 for demo so any distance triggers swipe
						// 	threshold:75
						// });

					},150);
				}

			},

			closeBtnInside: false,
			closeOnContentClick: true,
			midClick: true

			, gallery: {
				enabled: true, // set to true to enable gallery

				preload: [0,2], // read about this option in next Lazy-loading section

				navigateByImgClick: true,

				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

				tPrev: '<', // title for left button
				tNext: '>', // title for right button
				tCounter: '' // markup of counter
			}

			,image: {
				markup: '<div class="mfp-figure">'+
				// '<div class="mfp-close"></div>'+
				'<div class="mfp-img"></div>'+
				// '<div class="mfp-bottom-bar">'+
				// '<div class="mfp-title"></div>'+
				'</div>'+
				'</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
			}
        });

    }, 10);
}



_GD.slickNums = function ($gallery, $galleryNav, hideNav) {

    var slideCount = null;

    $gallery.on('init', function(event, slick) {
        slideCount = slick.slideCount;
        if (hideNav && slick.slideCount <= hideNav) {
            $galleryNav.addClass('hide');
            return;
        } else {
            $galleryNav.removeClass('hide');
        }
        setSlideCount();
        setCurrentSlideNumber(slick.currentSlide);
    });

    $gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        setCurrentSlideNumber(nextSlide);
    });

    function setSlideCount() {
        var $el = $('.slide-count-wrap', $galleryNav).find('.total');
        $el.text(slideCount);
    }

    function setCurrentSlideNumber(currentSlide) {
        var $el = $('.slide-count-wrap', $galleryNav).find('.current');
        $el.text(currentSlide + 1);
        $el.next('.hide').removeClass('hide');
    }
};
var _GD = _GD || {};
// _GD.siteUrl = 'http://md.пичуги.рф';
_GD.siteUrl = '';

_GD.initGallery = function() {
    $.when(_GD.gallery())
        .then(function( _gallery) {
            _GD.buildSliders(_gallery.data);
        })
        .fail(function() {
            //   console.log( 'I fire if one or more requests failed.' );
        });
}

_GD.gallery = function() {
        return $.ajax({
            url: _GD.siteUrl + '/json/gallery?page[size]=100&sort=datepublish',
            type: 'GET',
            dataType: 'json'
        });
    }




_GD.buildSliders = function(data) {
    // console.log("data", data);
    var cated = {};
    var all = [];
    var firstKey = '';
    $.each(data, function(i, v) {

        var key = v.attributes.slug;
        if (i == 0) {
            firstKey = key;
        }
        if (!cated[key]) {
            cated[key] = [];
        }
        if(v.attributes.images){
            $.each(v.attributes.images, function(idx, image) {
                if(image.active){
                    cated[key].push(image);
                    all.push(image);
                }
            });
        } else {
            delete cated[key];
        }

    });
    console.log("cated", cated);

    console.log("all", all);


    _GD.buildAll(all);

    // POINTERS
    // _GD.planPointers = [];
    var $plan = $('#plan');
    var $galleryPointers = $('#galleryPointers');
    var template =
        '<% for(var index in this) { %>' +
        '<a ~href="<% this[index].image.url %>">' +
        '<img data-lazy="<% (this[index].image.thumbnail).replace("300x300", "690x460") %>" />' +
        '</a>' +
        '<% } %>'
        ;
    // loop build gallery pointers
    // $.each(cated, function(i, v) {

    //     var hide = (_GD.planMode=='card') ? ' hide ' : '';
    //     // pointer
    //     var p = $('<img src="/t/p/i/icons/pointer.svg" id="p_'+i+'" rel="'+i+'" class="'+hide+'pointer _'+i+'" data-toggle="mapGallery mapGalleryContent iosFix" />');
    //     // _GD.planPointers.push(p);
    //     $plan.append(p);

    //     p.on('click', function () {
    //         var o = $(this);
    //         var pointer_counter = o.attr('rel');
    //         var c = $('<div id="c_'+pointer_counter+'" class="pointer-container _'+i+'" />');
    //         $galleryPointers.html(c);

    //         // var elem = new Foundation.Toggler($('#p_'+pointer_counter));
    //         // $('#p_'+pointer_counter).foundation('_setup', $('#p_'+pointer_counter));

    //         // console.log('template', _GD.Templa(template, all));
    //         c.html(_GD.Templa(template, v));

    //         var $galleryPointersNav = $('#galleryPointersNav');
    //         $('button', $galleryPointersNav).detach();
    //         _GD.slickNums(c, $galleryPointersNav, 1);

    //         c.slick({
    //             // lazyLoad: 'ondemand',
    //             lazyLoad: 'anticipated',
    //             swipeToSlide: true,
    //             slidesToShow: 1,
    //             slidesToScroll: 1,
    //             centerMode: true,
    //             arrows: !false,
    //             appendArrows: $galleryPointersNav,
    //             centerPadding: '0'
    //         });
    //     });
    // });
    // \\ loop
}



_GD.Templa = function(html, options) {
    var re = /<%([^%>]+)?%>/g,
        reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g,
        code = 'var r=[];\n',
        cursor = 0,
        match;
    var add = function(line, js) {
        js ? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
            (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
        return add;
    }
    while (match = re.exec(html)) {
        add(html.slice(cursor, match.index))(match[1], true);
        cursor = match.index + match[0].length;
    }
    add(html.substr(cursor, html.length - cursor));
    code += 'return r.join("");';
    return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
}
/*
var template =
'My skills:' +
'<%if(this.showSkills) {%>' +
    '<%for(var index in this.skills) {%>' +
    '<a href="#"><%this.skills[index]%></a>' +
    '<%}%>' +
'<%} else {%>' +
    '<p>none</p>' +
'<%}%>';
console.log(_GD.Templa(template, {
    skills: ["js", "html", "css"],
    showSkills: true
}));
*/
var _GD = _GD || {};

$(document).ready(function() {

/*

1. Есть главная страница ген.плана. На нем есть участки. Те участки, которые попадают под спец.предложение - выделяются каким-то там цветом, уже не помню.
2. Есть карточка участка куда мы попадаем, если тыкаем на конкретный участок. И здесь у нас следующее происходит:

- участок обычный - в нем указана цена, сотки, у озера или еще что-то (если попадает под фильтр). И раздел с коммуникациями, верно?
- спец.предложение - аналогичное, как пунктом выше, но добавляется этот раздел со спец.предложение + калькулятор. И раздел с коммуникациями, верно?

на главной стр.ген плана ничего у нас не всплывает про цену и спец.предлоежния. А калькулятор стоит только в тех карточках участков, где есть спец.предложения....

*/


        _GD.planBlocks = [
            '.houses_section',
            '.info_section',
            '.request_button_section',
            '.bottlenote_section',
            '.better_to_see_section',
            '.note_section',
            '.pointer',
        ];

        _GD.cardBlocks = [
            '.calc_section_wrapper',
            '.special_section',
        ];

        _GD.mapInited = function () {
            console.log("mapInited");
            $('#body > .spinner.loading').removeClass('loading');
            if($('#gallery').length){
                _GD.initGallery();
            }
        }

        _GD.mapIsNow = function () {
            _GD.planMode = 'map';
            // console.log("mapIsNow");
            // CHECK b-landing
            var isLandingRight = document.querySelector('.b-landing-plan-right')
            if (isLandingRight) {
                if (document.querySelector('.b-landing-plan-right--on-card')) {
                    setTimeout(function () {
                        var $target = $(isLandingRight);
                        // var $target = $('#map');
                        if($target.length) {
                            var target_offset = $target.offset();
                            var target_top = target_offset.top - 126;
                            // console.log('target_top', target_top);
                            $('html, body').animate({scrollTop:target_top}, 0);
                        }
                      }, 50);
                    $('.b-landing-plan-right').removeClass('b-landing-plan-right--on-card')
                }
            } else {
                window.scrollTo(0,0);
            }
            $(_GD.cardBlocks.join(',')).addClass('hide');
            $(_GD.planBlocks.join(',')).removeClass('hide');

            // FIXME:
            if($('#plan').hasClass('zoomed')){
                $('#body').addClass('ovfh');
            }
            var bds = $('#body')[0].dataset;
            console.log('bds.defaultCommunications_text', bds.defaultCommunications_text);
            console.log('bds.defaultCommunications_price', bds.defaultCommunications_price);
            console.log('bds.defaultCommunications_months', bds.defaultCommunications_months);
            if (bds.defaultCommunications_text) {
                $('#communications_text').html(bds.defaultCommunications_text);
                $('#communications_additional_text').html(bds.defaultCommunications_additional_text);
                $('#communications_price').html(_GD.toRublas(bds.defaultCommunications_price));
                $('#communications_months').html(bds.defaultCommunications_months + ' ' + _GD.declOfNum(parseInt(bds.defaultCommunications_months), ['месяц', 'месяца', 'месяцев']));
                $('#communications_per-months').html(_GD.toRublas(parseInt(bds.defaultCommunications_price) / parseInt(bds.defaultCommunications_months)));
            }

        }

        _GD.requestReserve = function () {
            console.log("selectedArea requestReserve", _GD.selectedArea);
            // toggle popup
            var address_1 = _GD.selectedArea.address + ' ' + _GD.selectedArea.number;
            var address_2 = ( _GD.selectedArea.address_2.length != 0 )? ' ('+_GD.selectedArea.address_2 + ' '+_GD.selectedArea.number_2 +')' : '';
            var area = _GD.selectedArea.area / 100;
            var data = address_1 + address_2 + ', ' + area + _GD.declOfNum(area, [' сотка', ' сотки', ' соток']);
            $('#requestReserveArea').val(data);
            $('#requestReserveContent .area').text(data);
            $('#requestReserve, #requestReserveContent, #iosFix').foundation('toggle');
        }
/*
        _GD.requesInstalment = function () {
            console.log("selectedArea requesInstalment", _GD.selectedArea);
            // toggle popup
            var address_1 = _GD.selectedArea.address + ' ' + _GD.selectedArea.number;
            var address_2 = ( _GD.selectedArea.address_2.length != 0 )? ' ('+_GD.selectedArea.address_2 + ' '+_GD.selectedArea.number_2 +')' : '';
            var area = _GD.selectedArea.area / 100;
            var data = address_1 + address_2 + ', ' + area + _GD.declOfNum(area, [' сотка', ' сотки', ' соток']);
            $('#requestInstalmentArea').val(data);
            $('#requestInstalmentContent .area').text(data);
            $('#requestInstalment, #requestInstalmentContent, #iosFix').foundation('toggle');
        }
*/
        _GD.requestCatalog = function () {
            $('#requestCatalog, #requestCatalogContent, #iosFix').foundation('toggle');
        }
        _GD.requestPrice = function (filter) {
            // 56005 Участки - 10 Соток
            // 56009 Участки - 12-15 Соток
            // 56013 Участки 16-20 Соток
            // 56017 Специальные Предложения. Запросить Прайс.
            var list = {
                '10 соток': 56005,
                '12-15 соток': 56009,
                '16-20 соток': 56013,
                'Специальные предложения': 56017,
                'Рассрочка На 12 Месяцев': 142441,
            };

            console.log("filter", filter);
            // toggle popup
            $('#requestPriceFilter').val(filter);
            $('#requestPriceContent form input[name="list"]').val(list[filter]);
            $('#requestPriceContent .filter-label').text(filter);
            $('#requestPrice, #requestPriceContent, #iosFix').foundation('toggle');
        }

        _GD.cardIsNow = function (area) {
            _GD.planMode = 'card';
            // console.log("cardIsNow", area);
            var isLandingRight = document.querySelector('.b-landing-plan-right')
            if (isLandingRight) {
                $('.b-landing-plan-right').addClass('b-landing-plan-right--on-card')
                setTimeout(function () {
                    var $target = $('#map');
                    if($target.length) {
                        var d = Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 768 ? 76 : -85
                        var target_offset = $target.offset();
                        var target_top = target_offset.top - d;
                        $('html, body').animate({scrollTop:target_top}, 0);
                    }
                  }, 50);
            } else {
                window.scrollTo(0,0);
            }
            // $('#back').scrollLeft(200);

            _GD.selectedArea = area;

            if ($('#body').hasClass('ovfh')) {
                // $('#body').foundation('toggle');
                $('#body').removeClass('ovfh')
            }

            if ($('.calc_section').length ) {
                $(_GD.cardBlocks.join(',')).removeClass('hide');
                // 15.08.19 теперь рассрочка на акционных не нужна
                // $('.communications_section').removeClass('hide'); // 15.08.19 Нужно, чтобы вот так было (14.12.17 . В спец.предложения раздел с коммуникациями убираем вообще.)
                $(_GD.planBlocks.join(',')).addClass('hide');
                if(_GD.selectedArea.special == "1"){
                    _GD.initCalc();
                    // 15.08.19 теперь рассрочка на акционных не нужна
                    // $('.communications_section').addClass('hide'); // 15.08.19 Нужно, чтобы вот так было (14.12.17 . В спец.предложения раздел с коммуникациями убираем вообще.)
                } else {
                    $(_GD.cardBlocks.join(',')).addClass('hide');
                }
            }

            var bds = $('#body')[0].dataset;

            console.log('bds.communications_text', bds.communications_text);
            console.log('bds.communications_price', bds.communications_price);
            console.log('bds.communications_months', bds.communications_months);
            if (bds.communications_text) {
                $('#communications_text').html(bds.communications_text);
                $('#communications_additional_text').html(bds.communications_additional_text);
                $('#communications_price').html(_GD.toRublas(bds.communications_price));
                $('#communications_months').html(bds.communications_months + ' ' + _GD.declOfNum(parseInt(bds.communications_months), ['месяц', 'месяца', 'месяцев']));
                $('#communications_per-months').html(_GD.toRublas(parseInt(bds.communications_price) / parseInt(bds.communications_months)));
            }

        }

        if ($('#map').length ) {
            _GD.mapIsNow();
        }

});

_GD.initCalc = function () {

    if(_GD.initialInputSlider){
        _GD.initialInputSlider.destroy();
        _GD.termInputSlider.destroy();
    }

    _GD.calc = {};
    _GD.calc.$calcPayment = $('#calcPayment');
    _GD.calc.$calcInterest = $('#calcInterest');

    _GD.calc.$specInitial = $('#specInitial');
    _GD.calc.$specPayment = $('#specPayment');

    var $body = $('#body');
    var $totalPrice = $('#totalPrice');

    var $initialInput = $("#initialInput");
    var $initialLabel = $("#initialLabel");
    var $termInput = $("#termInput");
    var $case1Llabel = $termInput.parents('.term').find('.case1');
    var $case2Llabel = $termInput.parents('.term').find('.case2');

    _GD.calc.price = parseInt($.trim($('#plan .detail .content div:contains("Стоимость земельного участка")').next('h3').text().replace(/\s/gi, '')));

    _GD.calc.min_initial = $body.data('min_initial'); // минимальный первоначальный взнос
    _GD.calc.initial     = $body.data('initial'); //  первоначальный взнос по умолчанию
    console.log('defaultCommunications_price', $body.data('defaultCommunications_price'));
    _GD.calc.cprice      = $body.data('communications_price') || $body.data('defaultCommunications_price'); // цена коммуникаций
    _GD.calc.percentage  = $body.data('percentage'); // годовая процентная ставка

    $('.case2 .percentage').text(_GD.calc.percentage+'%');

    _GD.calc.totalPrice  = _GD.calc.price + _GD.calc.cprice;
    $totalPrice.text(_GD.toRublas(_GD.calc.totalPrice));
    $initialLabel.text(_GD.toRublas(_GD.calc.min_initial));

    $initialInput.ionRangeSlider({
        force_edges: true,
        min: _GD.calc.min_initial,
        max: _GD.calc.price,
        from: _GD.calc.initial,
        step: 5000,
        onChange: function (data) {
            from = data.from;
            _GD.calculateInstalments(from);
        }
    });


    $termInput.ionRangeSlider({
        force_edges: true,
        grid_margin: !false,
        grid_snap: true,
        // grid_num: 24,
        min: 1,
        max: 24,
        from: 15,
        step: 1,
        grid: true,
        prettify: function(data){
            _data = _GD.declOfNum(data, ['месяц', 'месяца', 'месяцев']);
            return data + ' ' + _data;
        },
        onChange: function (data) {
            var from = data.from;
            if (from>12) {
                $case1Llabel.removeClass('active');
                $case2Llabel.addClass('active');
            } else {
                $case2Llabel.removeClass('active');
                $case1Llabel.addClass('active');
            }
            _GD.calculateInstalments(from);
        }
    });

    _GD.initialInputSlider = $initialInput.data("ionRangeSlider");
    _GD.termInputSlider = $termInput.data("ionRangeSlider");
    // http://jsfiddle.net/IonDen/zqh4o7uc/
    // initialInputSlider.update({
    //     from: 400000
    // });
    _GD.calculateInstalments();
}



_GD.toRublas = function(n, wrap) {
    if (n<0) {
        n = 0;
    }
    var _n = (parseInt(n)).toLocaleString('ru-RU', {style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0});
    var __n = _n;
    if (wrap) {
        __n = $(wrap);
        __n.text(_n);
        __n = __n[0].outerHTML;
    }
    return __n + ' ' + _GD.declOfNum(_n, ['рубль', 'рубля', 'рублей']);
}

_GD.calculateInstalments = function() {
    var initial = $("#initialInput").val();
    var term = $("#termInput").val();
    var percentage = 0;
    var payment = (_GD.calc.totalPrice - initial)/term;
    if (term > 12) {
        percentage = _GD.calc.percentage;
        var p = parseFloat(percentage)/1200; //переводим в доли за месяц
        var n = parseInt(term);// * 12;
        var S = parseInt(_GD.calc.totalPrice - initial);
            payment = S * p / (1 - Math.pow(1 + p, -n)); // http://htmllab.ru/kalkulyator-ipoteki/

    }
    _GD.calc.$specInitial.html(_GD.toRublas(initial, '<em />'));
    _GD.calc.$specPayment.html(_GD.toRublas(payment));

    _GD.calc.$calcPayment.text(_GD.toRublas(payment));
    _GD.calc.$calcInterest.text(_GD.toRublas((payment * term) - (_GD.calc.totalPrice - initial)) + ' ('+ percentage +'%)');
}
$(document).ready(function() {

  var $formRequestClone = $('#formRequest').clone();
  $formRequestClone.attr('id', 'formRequestPopup');
  // var $formRequestClone = jQuery.extend(true, {}, $('#formRequest'));
  // seed forms
  $('#requestContent .formContainer').append($formRequestClone);

  // 65733 Записаться На Экскурсию
  // 55993 Полный Каталог Домов
  // 56001 Записаться На Просмотр Домов
  // 56005 Участки - 10 Соток
  // 56009 Участки - 12-15 Соток
  // 56013 Участки 16-20 Соток
  // 56017 Специальные Предложения. Запросить Прайс.

  var $formRequestPriceClone = $('#formRequest').clone();
  $formRequestPriceClone.attr('id', 'formRequestPricePopup');
  $('#requestPriceContent .formContainer').append($formRequestPriceClone);
  $('#requestPriceContent form').prepend('<input type="hidden" name="requestPriceFilter" id="requestPriceFilter" value="" />');
  $('#requestPriceContent form input[name="source"]').val('Форма на прайс лист');
  // list populates in plan JS
  $('#requestPriceContent form input[name="list"]').val('');

  if ($('#map').length) {
    var $formRequestReserveClone = $('#formRequest').clone();
    $formRequestReserveClone.attr('id', 'formRequestReservePopup');
    $('#requestReserveContent .formContainer').append($formRequestReserveClone);
    $('#requestReserveContent form').prepend('<input type="hidden" name="requestReserveArea" id="requestReserveArea" value="" />');
    $('#requestReserveContent form input[name="source"]').val('Форма Бронь участка');
    $('#requestReserveContent form input[name="list"]').val('56589');

    // var $formRequestInstalmentClone = $('#formRequest').clone();
    // $('#requestInstalmentContent .formContainer').append($formRequestInstalmentClone);
    // $('#requestInstalmentContent form').prepend('<input type="hidden" name="requestInstalmentArea" id="requestInstalmentArea" value="" />');
    // $('#requestInstalmentContent form input[name="source"]').val('Форма Условия рассрочки');
    // $('#requestInstalmentContent form input[name="list"]').val('56589');
  }

  if ($('.houses_overview').length || $('#map').length) {
    var $formCatalogClone = $('#formRequest').clone();
    $formCatalogClone.attr('id', 'formRequestCatalog');
    $('#requestCatalogContent .formContainer').append($formCatalogClone);
    $('#requestCatalogContent form input[name="source"]').val('Запрос на полный каталог проектов');
    $('#requestCatalogContent form input[name="list"]').val('55993');
  }

  // Экскурсия и просмотр домов - бугивуги source+дшые в houses.js

  _GD.forms = [
    '#formRequest',
    '#formRequestCatalog',
    '#formCallback',
    '#formRequestPopup',
    '#formRequestPricePopup',
    '#formRequestReservePopup',
  ];

  _GD.formsPhones = [
    'input.tel__field',
  ];
  // , _GD.forms.join(',')
  $('input.error').on('input', function() {
    $(this).removeClass('error')
  });

  _GD.formIsValid = false;
  _GD.formIsSubmitted = false;

  _GD.submitForm = function($form) {

    if (!_GD.formIsValid) return;
    if (_GD.formIsSubmitted) return;

    _GD.formIsSubmitted = true;


    console.log('formIsSubmitted:');

    var data = $form.serialize();

    var action = '/submit_adaptive.php';
    var thnx = '/thanx/' + '?' + Math.random();
    var tel_field = $('.tel__field', $form);
    var $overlay = $form.parents('.overlay'),
        $popup = $form.parents('.popup');

    $form.find('.spinner').addClass('loading');


    if (tel_field.val().length < 1) {
      setTimeout(function() {
        tel_field.addClass('error');
        $('.tel-error', $popup).removeClass('invisible');
        $form.find('.spinner').removeClass('loading');
        _GD.formIsSubmitted = false;
      }, 1500);
    }else{
      tel_field.removeClass('error');
      setTimeout(function() {
        $('.tel-error', $popup).addClass('invisible');

        $('#thnxClose').trigger('click');
        if (!$overlay.hasClass('outofscreen')) {
          $overlay.find('.close').trigger('click');
        }
        $form.get(0).reset();
        $form.find('.spinner').removeClass('loading');
        _GD.formIsSubmitted = false;
      }, 1500);
    }

    // пережиток прошлого
    if (!_GD.thnx) {
      var ifrm = document.createElement("iframe");
      ifrm.setAttribute("src", thnx);
      ifrm.setAttribute("id", 'thnx');
      ifrm.style.width = "0px";
      ifrm.style.height = "0px";
      ifrm.style.display = "none";
      document.body.appendChild(ifrm);
      _GD.thnx = true;
      console.log('new:', $('iframe#thnx'));
    } else {
      $('iframe#thnx').attr('src', thnx);
      console.log('exists:', $('iframe#thnx'));
    }

    $.ajax({
        type: "POST",
        url: action,
        data: data
      })
      .done(function(response) {
        console.log('obj:' + action, response);
      });

  }
  //    });






  $(_GD.formsPhones.join(','))
    .attr('type', 'tel')
    .attr('autocomplete', 'off')
    .mask("+7 (000) 000-0000", {
      placeholder: "+7 (000) 000-0000",
      clearIfNotMatch: true
    })
    .on('focus click', function() {
      var $phone = $(this);
      if ($phone.val().length === 0) {
        $phone.val('+7 (');
        setTimeout(function() {
          $phone.setCursorPosition($phone.val().length);
        }, 10);
      }
    })
    .on('blur', function() {
      var $phone = $(this);
      if ($phone.val() === '+7 (') {
        $phone.val('');
      }
    });


  //SET CURSOR POSITION
  $.fn.setCursorPosition = function(pos) {
    this.each(function(index, elem) {
      if (elem.setSelectionRange) {
        elem.setSelectionRange(pos, pos);
      } else if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    });
    return this;
  };





  _GD.onDisabled = function(form) {
    $.each(form, function(i, _form) {
      var submit = $(_form).find('*[type=submit]');
      if (submit.hasClass('disabled')) return;
      // submit.attr('disabled','disabled').addClass('disabled');
    });
  };
  _GD.offDisabled = function(form) {
    $.each(form, function(i, _form) {
      var submit = $(_form).find('*[type=submit]');
      if (!submit.hasClass('disabled')) return;
      // submit.removeAttr('disabled').removeClass('disabled');
    });
  };

  // https://www.sitepoint.com/10-jquery-form-validation-plugins/
  // http://parsleyjs.org/doc/index.html#events


  $.each($(_GD.forms.join(',')), function(i, _form) {

    $(_form)
      .find('input').on('keyup', function(e) {
        if (e.which == 13) {
          console.log('e.which', e.which);
          console.log('form:submit');
          $(_form).trigger('form:submit');
        }
        return e.which !== 13;
      }).end()
      .parsley({
        uiEnabled: !false,
        trigger: 'keyup change blur input',
        validationThreshold: 1,
        errorClass: 'error',
        errorsWrapper: '<ul class="hide"></ul>'
      })
      .on('form:error', function(formInstance) {
        _GD.formIsValid = !true;
        //       console.log('error formInstance:', formInstance);
        return false;
      })
      .on('form:success', function(formInstance) {
        _GD.formIsValid = true;
        //       console.log('success formInstance:', formInstance);
        return false;
      })
      .on('form:submit', function(formInstance) {
        if (formInstance.isValid()) {
          _GD.formIsValid = true;
          _GD.submitForm(this.$element);
        }
        //       console.log('submit formInstance:', formInstance.isValid());
        return false;
      })
      .on('field:error', function() {
        //               console.log('Validation failed for: ', this.$element);
        if (!this.parent.isValid()) {
          _GD.onDisabled(this.parent.$element);
        }
      })
      .on('field:success', function() {
        //              console.log('Validation success for: ', this.$element);
        if (this.parent.isValid()) {
          _GD.offDisabled(this.parent.$element);
        }
      })
      ;

  });


  _GD.onDisabled($(_GD.forms.join(',')));

  // NOVALIDATE !!!


});

var _GD = _GD||{};


_GD.genGal = function(gals){

    $.each(gals, function(index, el) {

        var $gallery = $(el);
        if ($gallery.length) {

            var $galleryNav = $(el+'Nav');
            // TODO: title
            _GD.slickNums($gallery, $galleryNav, 1);

            $gallery.slick({
                // lazyLoad: 'ondemand',
                lazyLoad: 'anticipated',
                // responsive: true,
                // respondTo: 'slider',
                fade: !!$gallery.attr('data-fade')||false,
                swipeToSlide: true,
                slidesToShow: $gallery.attr('data-slides')||1,
                slidesToScroll: 1,
                centerMode: true,
                arrows: !false,
                appendArrows: $galleryNav,
                centerPadding: '0'
            });

        }
    });

    $(window).on('resize', function () {
        $.each(gals, function(index, el) {
            var $gallery = $(el);
            if ($gallery.length) {

                    var h1 = $gallery.height()||$gallery.parents('div').height();
                    // console.log($gallery.attr("id"));
                    // console.log("h1", h1);
                    // console.log("gallery.height", $gallery.height());
                    // console.log("outer gallery.height", $gallery.outerHeight());
                    // console.log("parents gallery.height", $gallery.parents('div').height());
                    var h = $gallery.outerHeight();
                    if(h>h1){
                        h = h1;
                    }
                    $gallery.find('.slick-slide').height(h);

            }
        });
    }).resize();
}


$(document).ready(function() {

    // setTimeout(function () {
    //     $('#body > .spinner.loading').removeClass('loading');
    // }, 1500);

    _GD.ideaGalleries = [
        '#galleryLandshaft',
        '#galleryCafe',
        '#galleryNeighbor',
    ];

    _GD.genGal( _GD.ideaGalleries );


    if ($('#galleryTide').length || $('#galleryHouses').length){

        _GD.mainGalleries = [
            '#galleryTide',
            '#galleryChildhood',
            '#galleryHouses',
            '#galleryNeighbors',
            '#galleryInsta',
        ];

        _GD.genGal( _GD.mainGalleries );

    }





/*
        var  el = '#rescuer';
        var wpinv = new Waypoint.Inview({
            element: el,
            offset: {
            //     _GDBottomPadding: '95%' // for fade + hide down: 'enter', up: 'exited',
            },
            enter: function(direction) {
                // console.log('Enter triggered with direction ' + direction);
                // SHOW

            },
            entered: function(direction) {
                // console.log('Entered triggered with direction ' + direction)

                if (direction == 'up') {
                    // start vidos
                    console.log("start vidos");
                    _GD.toggleVidos('#rescuer', 'on');
                }
            },
            exit: function(direction) {
                // console.log('Exit triggered with direction ' + direction);
                if (direction == 'down') {
                    // stop vidos
                    console.log("stop vidos");
                    _GD.toggleVidos('#rescuer', 'off');
                }
            },
            exited: function(direction) {
                // console.log('Exited triggered with direction ' + direction)
                // HIDE
            },
        });
*/

    _GD.playVidosInitial('#dock', 0.5);
    _GD.playVidosScroll('#dock', 0.5);

    _GD.playVidosInitial('#vinoKino', 0.5);
    _GD.playVidosScroll('#vinoKino', 0.5);

    _GD.playVidosInitial('#rescuer', 0.5);
    _GD.playVidosScroll('#rescuer', 0.5);


});



_GD.playVidosInitial = function(selector, threshold) {
    if (!threshold) {
        threshold = 0.1;
    }
    $(selector).data('threshold', threshold);

    $(selector).each(function(i, o) {
        if (inView.is(o)) {
            _GD.toggleVidos(selector, 'on');
        } else {
            _GD.toggleVidos(selector, 'off');
        }
    });
}


_GD.playVidosScroll = function(selector, threshold) {
    if (!threshold) {
        threshold = 0.1;
    }
    $(selector).data('threshold', threshold);


    inView(selector).on('enter', function(el) {
        _GD.toggleVidos(selector, 'on');
        var o = $(el);
            o.addClass('inview')
                .removeClass('outview');
    });

    inView(selector).on('exit', function(el) {
        _GD.toggleVidos(selector, 'off');
        var o = $(el);
            o.addClass('outview')
                .removeClass('inview');
    });
}

_GD.toggleVidos = function (selector, forceToStart) {
    // if(_GD.is_touch){
    //     return;
    // }
    if (!forceToStart) {
        forceToStart = false;
    }
    var vidos = $(selector).find('video');
    if (vidos.length) {

        if ( forceToStart === true ) {
            vidos.get(0).currentTime = 0;
            vidos.data('vidosPaused', true).get(0).pause();
            return;
        }
        if (forceToStart == 'off') {
            console.log(selector + " vidos to pause forced");
            vidos.data('vidosPaused', true).get(0).pause();
            return;
        }
        if (forceToStart == 'on') {
            console.log(selector +" vidos to play");
            vidos.removeData('vidosPaused').get(0).play();
            return;
        }

        // console.log(selector + "vidos is paused?", vidos.get(0).paused);
        if(vidos.get(0).paused) {
            console.log(selector +" vidos to play");
            vidos.removeData('vidosPaused').get(0).play();
        } else {
            console.log(selector + " vidos to pause");
            vidos.data('vidosPaused', true).get(0).pause();
        }
    }
};
$(document).ready(function() {
    // https://jsfiddle.net/b3kzaod9/3/

    // $('#requestCatalog').on('on.zf.toggler', function () {
    //     console.log("requestCatalog");
    // });
    //
    // $('#request').on('on.zf.toggler', function () {
    //     console.log("request");
    // });


$('*[data-toggle]').each(function(idx, obj){

	var o = $(obj);
	var targets = o.attr('data-toggle').split(' ');

    // console.log("targets", targets);
    // console.log("targets", targets.indexOf('requestContent'));

    if(targets.indexOf('requestContent') !== -1){

        _GD.initial_source = $('#requestContent input[name="source"]').val();
        console.log("initial_source", _GD.initial_source);

        o.on('click',function(e){

			console.log("o", o);

            var title           = $(this).attr('data-title');
            var source          = $(this).attr('data-source');
            // var price          = $(this).attr('data-price');
            // var catalog        = $(this).attr('data-catalog');
            console.log("source", source);

			// 65733 Записаться На Экскурсию
			// 56001 Записаться На Просмотр Домов

            if (source) {
                $('#requestContent h4').show();
                $('#requestContent h5').hide();
				$('#requestContent form input[name="source"]').val(source);
				$('#requestContent form input[name="list"]').val('56001');
            } else {
                $('#requestContent h5').show();
                $('#requestContent h4').hide();
				$('#requestContent form input[name="source"]').val(_GD.initial_source);
				$('#requestContent form input[name="list"]').val('65733');
            }


        });
    }


});



if ($('.house').length) {


    _GD.genGal(['#houseGallery']);

        // $('#houseGallery').slick('slickSetOption', 'fade', true);
        // $('#houseGallery').slick('slickSetOption', 'asNavFor', '.house .visual_wrapper .previews', true);



    // main_pic
    $("#houseGallery").siblings(".previews").slick({
        lazyLoad:"anticipated",
        slidesToShow: 4,
        // slidesToScroll: 1,
        // centerMode: true,
        // centerPadding: '19%',
        variableWidth: true,
        focusOnSelect: true,
        asNavFor: '#houseGallery',
        autoplay: 0,
        responsive: [

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    // centerPadding: '15.67%',
                    dots: false
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    // centerPadding: '19%',
                    dots: false
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    // centerPadding: '24%',
                    dots: false
                }
            }
        ]
    });

    $('.house .visual_wrapper .main_pic').on('beforeChange', function(event,slick,slide,nextSlide) {
        //    $('.slider-nav-1').find('.slick-slide').removeClass('slick-current').eq(nextSlide).addClass('slick-current');
    });
}
});
$(document).ready(function() {
    if ($('.event_slick').length) {

        _GD.eventsGalleries = [];

        $('.event_slick').each(function(index, el) {
            var id = $(el).attr('id');
            if (id) {
                _GD.eventsGalleries.push('#'+id)
            }
        });

        _GD.genGal( _GD.eventsGalleries );
    }


/*
 ######  ##     ##  #######  ##      ##    ##     ##  #######  ########  ########
##    ## ##     ## ##     ## ##  ##  ##    ###   ### ##     ## ##     ## ##
##       ##     ## ##     ## ##  ##  ##    #### #### ##     ## ##     ## ##
 ######  ######### ##     ## ##  ##  ##    ## ### ## ##     ## ########  ######
      ## ##     ## ##     ## ##  ##  ##    ##     ## ##     ## ##   ##   ##
##    ## ##     ## ##     ## ##  ##  ##    ##     ## ##     ## ##    ##  ##
 ######  ##     ##  #######   ###  ###     ##     ##  #######  ##     ## ########
*/
    $(document).on('click', '.showmorelife', function(e) {

        e.preventDefault();
        var el = $(this);
        var url = el.attr('href');
        var p = el.parents('.showmore');
        var spinner = el.parents('.showmore').find('.spinner')
        spinner.addClass('loading');

        $.ajax({
                type: "GET",
                url: url
            })
            .done(function(response) {
                p.detach();
                var response_div = $('<div class="jitem opa">'+response+'</div>');
                $('.jitems').append(response_div);
                setTimeout(function () {
                    $('.jitems').find('.opa').removeClass('opa');
                }, 5);
            });


    });

    // onbeforeunload

    function WinClose() {
        $('#body > .spinner').addClass('loading');
    }
    window.onbeforeunload = WinClose;
});